import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "leaflet/dist/leaflet.css";
import "./style/previseo.css";
import "./style/previseo-btn.css";
import "./style/previseo-screen-targets.css";
import "./style/previseo-train-line.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./utils/leaflet/leaflet-setup";
import "./i18next-config";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
